function useStyles() {
    return {
        container: (isDocument:boolean) => ({
            height: !isDocument ? 'calc(100% - 50px)' : '100%',
            '& video': {
                width: "100%", 
                height: "100%", 
                objectFit: "contain"
            },
            '& img': {
                width: "100%", 
                height: "100%", 
                objectFit: "contain"
            },
        }),
        mainContainer: {
            width: '100vw',
            height: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'white'
        }
    }
}

export { useStyles }
